const UploadAttachmentComponent = {
    templateUrl: '/formViewer/component/uploadAttachment/uploadAttachment.tpl.html',
    controller: 'uploadAttachmentController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umCore')
    .component('uiUploadAttachment', UploadAttachmentComponent);
